import IconMeter from '@assets/icons/meter.svg?react';
import IconMoon from '@assets/icons/moon.svg?react';
import IconNav from '@assets/icons/nav.svg?react';
import IconSettings from '@assets/icons/settings.svg?react';
import IconSun from '@assets/icons/sun.svg?react';
import {
 AppBar,
 Box,
 IconButton,
 Toolbar,
 useColorScheme,
 useTheme,
} from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { useNavigate } from 'react-router-dom';
import buildversion from '../../../../buildversion?raw';
import layoutSizes from '../../../utils/layoutSizes';
import UserWidget from './UserWidget';

const Header = ({
 isSidebarOpen,
 setIsSidebarOpen,
}: {
 isSidebarOpen: boolean;
 setIsSidebarOpen: Dispatch<SetStateAction<boolean>>;
}) => {
 const { mode, setMode } = useColorScheme();
 const theme = useTheme();
 const appVersion = buildversion.trim();
 const navigate = useNavigate();

 return (
  <AppBar
   elevation={0}
   position="fixed"
   sx={{
    height: layoutSizes.headerHeight,
    width: isSidebarOpen
     ? { xs: '100%', md: `calc(100% - ${layoutSizes.sidebarWidth}px)` }
     : { xs: '100%', md: 'calc(100% - 76px)' },
    ml: isSidebarOpen
     ? { xs: '100%', md: `${layoutSizes.sidebarWidth}px` }
     : { xs: '0px', md: '76px' },
    boxShadow: 'none',
    background: theme.palette.kemek.bg2,
    borderBottom: `1px solid ${theme.palette.kemek.lightestGray}`,
   }}
  >
   <Toolbar sx={{ height: '100%' }}>
    <IconButton
     size="large"
     edge="start"
     color="inherit"
     aria-label="menu"
     sx={{ mr: 2, width: 44, height: 44 }}
     onClick={() => setIsSidebarOpen((prevState) => !prevState)}
    >
     <IconNav style={{ color: theme.palette.kemek.darkestGray }} />
    </IconButton>

    {/* <Search /> */}
    <Box
     sx={{
      gap: { xs: '24px', md: '32px' },
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
     }}
    >
     {/* <Box>localStorage: {lsSize()}</Box> */}
     <IconButton
      size="large"
      sx={{ p: '4px', height: 24, display: { xs: 'block', md: 'none' } }}
      edge="start"
      color="inherit"
      aria-label="menu"
     >
      <IconMeter />
     </IconButton>
     {/* <Box
						sx={{
							display: { xs: 'none', md: 'flex' },
							alignItems: 'center',
							gap: '20px',
						}}
					>
						<ScalesWidget />
						<ScalesWidget />
					</Box> */}
     <UserWidget />
     <Box
      sx={{
       display: { xs: 'none', md: 'flex' },
       alignItems: 'center',
       fontSize: 12,
       color: theme.palette.kemek.lightGray,
      }}
     >
      {appVersion || '-'}
     </Box>
     <IconButton
      onClick={() => setMode(mode === 'dark' ? 'light' : 'dark')}
      size="large"
      sx={{
       p: '0px',
       width: 24,
       height: 24,
       ml: 0,
       display: { xs: 'none', md: 'flex' },
      }}
      edge="start"
      color="inherit"
      aria-label="toggle color mode"
     >
      {mode === 'dark' ? (
       <IconMoon
        style={{
         color: theme.palette.kemek.darkestGray,
         width: 24,
         height: 24,
        }}
       />
      ) : (
       <IconSun
        style={{
         color: theme.palette.kemek.darkestGray,
         width: 24,
         height: 24,
        }}
       />
      )}
     </IconButton>
     <IconButton
      onClick={() => navigate('/admin/users')}
      size="large"
      sx={{
       p: '0px',
       width: 24,
       height: 24,
       ml: 0,
       display: { xs: 'none', md: 'flex' },
      }}
      edge="start"
      color="inherit"
      aria-label="open admin dashboard"
     >
      <IconSettings
       style={{
        color: theme.palette.kemek.darkestGray,
        width: 24,
        height: 24,
       }}
      />
     </IconButton>
    </Box>
   </Toolbar>
  </AppBar>
 );
};

export default Header;

